import React from 'react';
import { Content, ItemCardGrid, ContentHeader } from '@backstage/core-components';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { TemplateCard } from '../TemplateCard/TemplateCard.esm.js';

const TemplateGroup = (props) => {
  const {
    templates,
    title,
    components: { CardComponent } = {},
    onSelected
  } = props;
  const titleComponent = typeof title === "string" ? /* @__PURE__ */ React.createElement(ContentHeader, { title }) : title;
  if (templates.length === 0) {
    return null;
  }
  const Card = CardComponent || TemplateCard;
  return /* @__PURE__ */ React.createElement(Content, null, titleComponent, /* @__PURE__ */ React.createElement(ItemCardGrid, null, templates.map(({ template, additionalLinks }) => /* @__PURE__ */ React.createElement(
    Card,
    {
      key: stringifyEntityRef(template),
      additionalLinks,
      template,
      onSelected
    }
  ))));
};

export { TemplateGroup };
//# sourceMappingURL=TemplateGroup.esm.js.map
